import { Action } from './action';

export class RemoveLoginToken extends Action {
}

export class RefreshLoginToken extends Action {
    constructor(public username: string, public refreshToken: string) {
        super();
    }
}
